import React from 'react';
import { Done } from '../../../icons/Done/Done.js';
import { useTheme } from '../../../theme/Theme.js';
import { Label, Input, Text } from './styled.js';

const Chip = React.memo(({ checked, value, onClick }) => {
    const theme = useTheme();
    const handleClick = React.useCallback((e) => {
        e.preventDefault();
        onClick(value);
    }, [onClick, value]);
    return (React.createElement(Label, { "$checked": checked, theme: theme, onClick: handleClick },
        React.createElement(Input, { type: 'checkbox' }),
        checked && React.createElement(Done, null),
        React.createElement(Text, null, value)));
});

export { Chip };
//# sourceMappingURL=Chip.js.map
